import theme from 'styled-theming';
import { Color } from '../constants/Color';

const textColor = theme('mode', {
  light: '#1C1E21',
  dark: '#F5F6F7',
});

const backgroundColor = theme('mode', {
  light: '#FFFFFF',
  dark: '#18191A',
});

const navbarColor = theme('mode', {
  light: '#fff',
  dark: 'rgb(36, 37, 38)',
});

const navbarDrawerItemHover = theme('mode', {
  light: '#F2F2F2',
  dark: '#292A2B',
});

const cardBackgroundColor = theme('mode', {
  light: '#FFFFFF',
  dark: '#0C0C0D',
});

const radioColor = theme('mode', {
  light: '#f50057',
  dark: '#38c2a0',
});

const datePickerColor = theme('mode', {
  light: 'invert(0)',
  dark: 'invert(1)',
});

const tabPanelColor = theme('mode', {
  light: '#F5F5F5',
  dark: 'rgb(36, 37, 38)',
});
const itemSideBarColor = theme('mode', {
  light: '#f2f2f2',
  dark: '#242526',
})

const iconItemSideBarColor = theme('mode', {
  light: '#7f7f7f',
  dark: '#8b8b8c',
})

const sideBarTextColor = theme('mode', {
  light: '#606770',
  dark: '#d3d6da',
})

const highlightTextColor = theme('mode', {
  light: '#ebedf0',
  dark: '#444950',
})

const labelTextField = theme('mode', {
  light: Color.BaliHai,
  dark: '#51c3a0',
})

const buttonDisabledBgColor = theme('mode', {
  light: Color.BaliHai,
  dark: 'gray',
});

const appTheme = {
  textColor,
  backgroundColor,
  navbarColor,
  navbarDrawerItemHover,
  cardBackgroundColor,
  radioColor,
  datePickerColor,
  tabPanelColor,
  itemSideBarColor,
  iconItemSideBarColor,
  sideBarTextColor,
  highlightTextColor,
  labelTextField,
  buttonDisabledBgColor,
};

export default appTheme;
